var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"gite"},[_c('div',{staticClass:"gdf-WidgetBooking",attrs:{"data-source":"owner","data-reference":"H32G026866"}})])])}]

export { render, staticRenderFns }